import React from 'react';

const BrandContext = React.createContext({});

export { BrandContext };
